import axios from '@/libs/axios'

/**
 * 获取妥投报表统计数据（统一接口）
 * @param {Object} params 查询参数
 * @param {string} params.internalChannel 内部渠道
 * @param {string} params.externalChannel 外部渠道
 * @param {Array} params.dateRange 日期范围
 * @param {string} params.type 趋势类型：daily/weekly
 * @returns {Promise} 返回包含饼图、折线图和列表数据的统一响应
 */
export const getDeliveryReportStatistics = (params) => {
  return axios.request({
    url: '/ndt/delivery/report/statistics',
    method: 'post',
    data: {
      channel: params.channel,
      startTime: params.startDate,
      endTime: params.endDate,
      siteId: params.siteId
    }
  })
}

/**
 * 导出妥投报表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export const exportDeliveryReport = (params) => {
  return axios.request({
    url: '/api/delivery/export',
    method: 'post',
    data: params,
    responseType: 'blob'
  })
}

/**
 * 获取渠道列表
 * @returns {Promise}
 */
export const getChannelList = () => {
  return axios.request({
    url: '/api/delivery/channels',
    method: 'post',
    data: {}
  })
}

// Mock数据 - 用于开发测试，匹配新的接口返回格式
export const mockDeliveryReportStatistics = {
  data: {
    // 饼图数据 - DeliveryReportPieResp[]
    pieList: [
      {
        days: '1-3天',
        percent: 42.5,
        quantity: 1048
      },
      {
        days: '4-5天',
        percent: 29.8,
        quantity: 735
      },
      {
        days: '6-7天',
        percent: 23.5,
        quantity: 580
      },
      {
        days: '8-10天',
        percent: 19.6,
        quantity: 484
      },
      {
        days: '10天以上',
        percent: 12.2,
        quantity: 300
      }
    ],
    
    // 折线图数据 - DeliveryReportLineResp[]
    lineList: [
      {
        days: '1-3天',
        percent: 84.92,
        quantity: 1234
      },
      {
        days: '4天',
        percent: 77.16,
        quantity: 1156
      },
      {
        days: '5天',
        percent: 69.42,
        quantity: 1089
      },
      {
        days: '6-60天',
        percent: 62.42,
        quantity: 998
      },
      {
        days: '61天以上',
        percent: 61.99,
        quantity: 876
      }
    ],
    
    // 列表数据 - DeliveryReportListResp[]
    list: [
      {
        days: '1-3天',
        totalQuantity: 1234,
        percent: 84.92,
        notDeliveredYetQuantity: 186
      },
      {
        days: '4天',
        totalQuantity: 1156,
        percent: 77.16,
        notDeliveredYetQuantity: 264
      },
      {
        days: '5天',
        totalQuantity: 1089,
        percent: 69.42,
        notDeliveredYetQuantity: 333
      },
      {
        days: '6-60天',
        totalQuantity: 998,
        percent: 62.42,
        notDeliveredYetQuantity: 375
      },
      {
        days: '61天以上',
        totalQuantity: 876,
        percent: 61.99,
        notDeliveredYetQuantity: 333
      }
    ]
  }
}

// 渠道列表数据
export const mockChannelList = {
  internalChannels: [
    { value: 'channel1', label: '内部渠道1' },
    { value: 'channel2', label: '内部渠道2' },
    { value: 'channel3', label: '内部渠道3' }
  ],
  externalChannels: [
    { value: 'external1', label: '外部渠道1' },
    { value: 'external2', label: '外部渠道2' },
    { value: 'external3', label: '外部渠道3' }
  ]
}

// 兼容性函数 - 为了保持向后兼容，将新数据格式转换为旧格式
export const mockDeliveryReportResponse = () => {
  const statistics = mockDeliveryReportStatistics.data
  
  return {
    data: {
      // 表格数据 - 从list转换
      tableData: statistics.list.map((item, index) => ({
        key: (index + 1).toString(),
        timePeriod: item.days,
        totalOrders: item.totalQuantity,
        deliveredOrders: item.totalQuantity - item.notDeliveredYetQuantity,
        deliveryRate: item.percent.toFixed(2),
        undeliveredOrders: item.notDeliveredYetQuantity
      })),
      
      // 饼图数据 - 从pieList转换
      pieChartData: statistics.pieList.map((item, index) => ({
        value: item.quantity,
        name: item.days,
        itemStyle: { 
          color: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de'][index % 5] 
        }
      })),
      
      // 趋势数据 - 从lineList转换
      trendData: {
        dates: statistics.lineList.map(item => item.days),
        deliveryRates: statistics.lineList.map(item => item.percent),
        totalOrders: statistics.lineList.map(item => item.quantity)
      }
    }
  }
}

// Mock趋势数据函数
export const mockTrendData = () => {
  const statistics = mockDeliveryReportStatistics.data
  return {
    dates: statistics.lineList.map(item => item.days),
    deliveryRates: statistics.lineList.map(item => item.percent),
    totalOrders: statistics.lineList.map(item => item.quantity)
  }
}
